import { Instance, types } from 'mobx-state-tree';

export const PostalCodeValidation = types.model('PostalCodeValidation', {
  validRegEx: types.string,
  allowedCharactersRegEx: types.string
});

export type PostalCodeValidation = Instance<typeof PostalCodeValidation>;
